export default __webpack_public_path__ + "static/media/DSC_0547.db0a6d18.jpg";